import React, { FC } from 'react';
import styled from 'styled-components';

import { NgCard, NgCardContent, NgCardTitle } from '../UI';
import { WorkbookUpload } from '../Projects';

const StyledWorkbookContainer = styled.div`
  margin-top: 10px;
`;

interface Props {
  data?: any;
  targetKey?: string;
  targetId?: number;
  uploadFolderId: number;
  onComplete: (data: any) => void;
}

export const NgWorkbookUploadCard: FC<Props> = ({ data, uploadFolderId, targetKey, targetId, onComplete }) => {
  return (
    <NgCard>
      <NgCardContent>
        <NgCardTitle title="Workbook upload" />

        <StyledWorkbookContainer>
          <WorkbookUpload project={data} uploadFolderId={uploadFolderId} targetKey={targetKey} targetId={targetId} onComplete={onComplete} />
        </StyledWorkbookContainer>
      </NgCardContent>
    </NgCard>
  );
};
